var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Breadcrumb',{staticClass:"my",attrs:{"separator":" >> "}},_vm._l((_vm.BreadcrumbList),function(item,itemIndex){return _c('Breadcrumb-item',{key:itemIndex},[_vm._v(_vm._s(item))])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }